import { BareActionContext } from 'vuex-typex'
import { CommentState } from '../state'
import { RootState } from '../..'
import { MetaService } from '../../../service/MetaService'
import TYPES from '../../../config/Types'
import commentStore from '../comment-store'
import commentUtils from './comment-utils'
import setMeta from './set-meta'
import { Meta } from '../../../model/meta'
import { IComment } from '../../../model/comment'
import { IUser, UserMeta } from '../../../model/user'
import userStore from '../../user/user-store'

export default async function fetchCreator(context: BareActionContext<CommentState, RootState>, comment: IComment) {
    commentUtils.commentService.getCreator(comment).then((creator: IUser) => {
        if (creator && creator.id) {
            if (!userStore.state.users.has(creator.id)) {
                console.log('setting user in map: %j', creator)
                creator.meta = new UserMeta()
                userStore.commitSetUser({ user: creator })
                userStore.dispatchSetMeta(creator)
            }
            console.log('setting creatpr in convo: %j', userStore.state.users.get(creator.id))
            commentStore.commitSetCreator({ comment: comment, creator: userStore.state.users.get(creator.id) as IUser })
        }
    })

    return
}
